export default "__VITE_ASSET__77157891__"